export default "__VITE_ASSET__CqZKBypb__"